var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    colors = _ref.colors;
  return {
    answerMediaIconMargin: spacing.xSmall,
    embeddedImageMargin: spacing.xSmall,
    embeddedImagePadding: spacing.small,
    mediaToggleMargin: spacing.xSmall,
    mediaToggleColor: colors.contrasts.grey1214
  };
};
export default generateComponentTheme;